import { CampaignService } from "@entities/campaigns/lib/services/Campaign.service";
import { useMutation } from "@shared/lib/hooks";
import { IRegisterBankDetailsRequest } from "@shared/lib/types/briefCampains";
import {
  PAYOUT_EXPORTS_QUERY_KEY,
  PAYOUTS_FACETS_QUERY_KEY,
  PAYOUTS_QUERY_KEY,
} from "../contsants";

export function useRegisterBankDetails() {
  const {
    mutate: registerBankDetails,
    isLoading: isRegistering,
    isSuccess: isRegistered,
    isError,
    error,
    data,
  } = useMutation({
    mutationFn: async (request: IRegisterBankDetailsRequest) => {
      return await CampaignService.registerBankDetails(request);
    },
    onSuccess: (client) => {
      client.invalidateQueries({ queryKey: [...PAYOUTS_QUERY_KEY()] });
      client.invalidateQueries({ queryKey: [...PAYOUTS_FACETS_QUERY_KEY()] });
      client.invalidateQueries({ queryKey: [...PAYOUT_EXPORTS_QUERY_KEY()] });
    },
    options: { skipInvalidation: true },
  });

  return {
    registerBankDetails,
    isRegistering,
    isRegistered,
    isError,
    error,
    data,
  };
}
